'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./context-menu-separator.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContextMenuSeparator = function ContextMenuSeparator() {
  return _react2.default.createElement('li', { className: 'context-menu-separator' });
};

exports.default = ContextMenuSeparator;